import { z } from 'zod'

const FromTimepointSubmissionValidationSchema = z.object({
  new_status: z
    .enum(['INACTIVE', 'IN_PROGRESS', 'COMPLETE', 'NOT_STARTED', 'LOCKED', 'MISSED', 'REOPENED', 'ACTIVE'] as const)
    .optional(),
})

const ToTimepointSubmissionValidationSchema = z.object({
  new_status: z
    .enum(['INACTIVE', 'IN_PROGRESS', 'COMPLETE', 'NOT_STARTED', 'LOCKED', 'MISSED', 'REOPENED', 'ACTIVE'] as const)
    .optional(),
  timepoint_submission_id: z.string().uuid(),
})

export const ExamReassignementValidationSchema = z.object({
  exam_metadata_ids: z.array(z.string().uuid()).min(1),
  from_timepoint_submission: FromTimepointSubmissionValidationSchema,
  to_timepoint_submission: ToTimepointSubmissionValidationSchema,
  selected_subject_id: z.string().uuid().optional(),
})

export const ExamReassignementEsignValidationSchema = z.object({
  username: z.string().min(1),
  password: z.string().min(1),
  context: z.object({
    type: z.literal('timepoint_exam_reassignment'),
    exam_reassignment: ExamReassignementValidationSchema,
  }),
})

export const ExamReassignementFormValidationSchema = ExamReassignementValidationSchema

export type ExamReassignementEsignFormValues = z.infer<typeof ExamReassignementEsignValidationSchema>
export type ExamReassignementFormValues = z.infer<typeof ExamReassignementFormValidationSchema>
